import { render, staticRenderFns } from "./accueil.vue?vue&type=template&id=2181de59&scoped=true&"
import script from "./accueil.vue?vue&type=script&lang=js&"
export * from "./accueil.vue?vue&type=script&lang=js&"
import style0 from "./accueil.vue?vue&type=style&index=0&id=2181de59&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2181de59",
  null
  
)

export default component.exports